<!--
 * @Description  :
 * @Author       : 吴鑫
 * @Date         : 2023-02-24 17:15:34
 * @LastEditors  : wuxuebing
 * @LastEditTime : 2023-06-15 10:14:12
 * @FilePath     : \dx_execute_admin\src\components\panel\Panel.vue
-->
<!-- 表格标题组件 -->
<template>
	<div class="panel">
		<div class="title" @click="state = !state">
			<svg-icon :class="{ open: state }" class="icon" icon-class="sanjiao_fill"></svg-icon>
			<span>{{ title }}</span>
			<span class="red-color">{{warningTitle}}</span>
		</div>
		<div v-show="state">
			<slot></slot>
		</div>
	</div>
</template>

<script>
// import svgIcon from '@/components/svgIcon'
export default {
	props: {
		title:{
			type: String,
			default: ''
		},
		warningTitle:{
			type: String,
			default: ''
		}
	},
	components: {},
	data() {
		return {
			state: true
		}
	},

	computed: {},
	created() {},

	mounted() {},

	methods: {}
}
</script>
<style lang="less" scoped>
.panel {
	margin-bottom: 20px;
	.title {
		// margin: 0 20px 0 20px;
		width: auto;
		height: 40px;
		background: #eff6fe;
		line-height: 40px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		font-size: 14px;
		font-weight: 400;
		color: #000000;
		// line-height: 20px;
		margin-bottom: 10px;
		.icon {
			fill: #7a94b1;
			transition: 0.1s;
			margin-right: 6px;
			transform: rotateZ(180deg);
			&.open {
				transform: rotateZ(0deg);
			}
		}

		.red-color {
            color: red;
		}
	}
}
</style>
